// extracted by mini-css-extract-plugin
module.exports = {"root":"_cf5277ab","isNewVariant":"_43d17592","isNewsVariant":"_0fdf56b4","isPromoVariant":"_4865d86b"};